import { Stages } from '..';
import type { AnyBackendPlacementStage } from '../../../../create-placement/types';

export const applyHydrate = (hydrate: AnyBackendPlacementStage | undefined) =>
	Stages.maybe(hydrate);
